import { SKELETON_TYPE_TYPE, type SkeletonTypeType } from '@kc-console/context';

import type { PageSkeletonVariant } from '@kc-console/common-ui';

/**
 * SkeletonTypeType을 PageSkeletonVariant로 변환합니다.
 * @description
 * - 라우트의 skeletonType을 PageSkeleton 컴포넌트의 variant prop에 맞는 형식으로 변환합니다.
 * - SKELETON_TYPE_TYPE.LIST → 'list'
 * - SKELETON_TYPE_TYPE.DETAIL → 'detail'
 * - SKELETON_TYPE_TYPE.CREATE → 'create'
 * - skeletonType이 제공되지 않거나 알 수 없는 값인 경우 기본값 'list'를 반환합니다.
 * @param skeletonType - 변환할 스켈레톤 타입 (LIST, DETAIL, CREATE)
 * @returns PageSkeleton 컴포넌트에서 사용할 variant 값 ('list' | 'detail' | 'create')
 * @example
 * // urlMatchedRoute의 skeletonType을 PageSkeleton variant로 변환
 * <PageSkeleton variant={getPageSkeletonVariant(urlMatchedRoute?.skeletonType)} />
 */
export const getPageSkeletonVariant = (
  skeletonType?: SkeletonTypeType,
): PageSkeletonVariant | null => {
  switch (skeletonType) {
    case SKELETON_TYPE_TYPE.LIST:
      return 'list';
    case SKELETON_TYPE_TYPE.DETAIL:
      return 'detail';
    case SKELETON_TYPE_TYPE.CREATE:
      return 'create';
    default:
      return null;
  }
};
